export default "__VITE_ASSET__D$Y88V9Q__"